import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { environment } from './../../../environments/environment';
// Set global for Highcharts
Highcharts.setOptions({
  time: {
    useUTC: false
  }
});
export const Moment$ = moment;
export const Highcharts$ = Highcharts;
export const API_ENDPOINT$ = `${environment.APIEndpoint}`;
export const API_BASE$ = `${environment.APIEndpoint}`;
export const CLIENT_ID$ = `${environment.client_id}`;
export const CLIENT_SECRET$ = `${environment.client_secret}`;
export const APP_ID$ = `${environment.appId}`;
export const TENANT_ID$ = `${environment.config.tenantId}`;
export const OPEN_WEATHER_ENDPOINT$ = 'http://api.openweathermap.org/data/2.5/';
export class AppUtils {
  public static paserMetersPowerData = (data: any): Map<string, any[]> => {
    const values = Object.values(data);
    const result = new Map<string, any[]>();
    values.forEach((x) => {
      Object.values(x).forEach((y) => {
        for (const [key, value] of Object.entries(y)) {
          if (result.has(key)) {
            const currentValues = result.get(key);
            result.set(key, currentValues.concat(value));
          } else {
            result.set(key, [].concat(value));
          }
        }
      });
    });
    return result;
  };
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public static uniqueArray = (a: any) => {
    const seen = {};
    const out = [];
    const len = a.length;
    let j = 0;
    for (let i = 0; i < len; i++) {
      const item = a[i];
      if (seen[item] !== 1) {
        seen[item] = 1;
        out[j++] = item;
      }
    }
    return out;
  };
  public static hasValueNotEmpty = (variable: any) => {
    return (
      typeof variable !== 'undefined' &&
      variable !== null &&
      variable.length !== 0
    );
  };
}
